import React from 'react';
import { Helmet } from 'react-helmet-async';
import CustomerNavigation from '../../components/CustomerNavigation';
import KakaoChatButton from '../../components/KakaoChatButton';
import HeroSection from './components/HeroSection';
import BeforeAfterPreview from './components/BeforeAfterPreview';
import ProcessSteps from './components/ProcessSteps';
import ServiceOverview from './components/ServiceOverview';
import CTASection from './components/CTASection';
import SiteFooter from '../../components/SiteFooter';

const CustomerHome = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>sneaker - 가까운/올바른 손질로</title>
      </Helmet>
      <CustomerNavigation />
      
      <main className="mx-auto max-w-[960px] px-4 py-8 sm:px-6 lg:px-8">
        <div className="space-y-8">
          <HeroSection />
          <BeforeAfterPreview />
          <ProcessSteps />
          <ServiceOverview />
          <CTASection />
        </div>
      </main>

      <KakaoChatButton />
      <SiteFooter />
    </div>
  );
};

export default CustomerHome;